@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.headerWrapper {
  display: flex;
  align-items: flex-end;
  gap: 18px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.contentWrapper {
  min-height: 300px;
}

.styledButtonGroup {
  [data-button-group] {
    @include border-radius-r2;
    width: 372px;
  }

  [data-button-group-item] {
    padding: 4px 8px;
  }
}

.title {
  @include typography-v2-title-md;
  color: var(--text-default);
}

.windowTitleText {
  @include typography-v2-ui-xs;
  color: var(--text-soft);
}

.windowDescription {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: fit-content;
  border-radius: 100px;
  background: var(--surface-default);
  padding: 0 8px;
}
